import React from "react";
import { useTranslation } from "react-i18next";
import * as API from "../api.js";
import { setActiveMissignKeyHandler } from "./i18n.js";

export default function useLoad(type) {
    const { i18n } = useTranslation();

    React.useEffect(() => {
        API.Send("/lang/pack", { type }).then(res => {
            i18n.changeLanguage(res.lang, (err, t) => {
                i18n.removeResourceBundle("en", "translation");
                i18n.addResourceBundle(res.lang, "translation", res.pack, true, true);

                setActiveMissignKeyHandler(true);
            });
        });
    }, [i18n.language]);

    return null;
}
